import React from "react";
import PropTypes from "prop-types";

import { useStyles, BorderLinearProgress } from "./LinearProgress.styles";

const LinearProgress = ({ value }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <BorderLinearProgress
        variant="determinate"
        value={value}
        color="primary"
      ></BorderLinearProgress>
      <span className={classes.label}>{value.toFixed(2) + "%"}</span>
    </div>
  );
};

LinearProgress.defaultProps = {
  value: 50,
};

LinearProgress.propTypes = {
  value: PropTypes.number,
};

export { LinearProgress };
